<template>
  <div class="outer-content">
    <div class="inner-content">

      <div class="player-select-header" v-html="T('Select_Avatar')"></div>

      <b-row class="player-selection-box justify-content-center" v-if="playGame">

        <b-col class="d-flex justify-content-center align-items-center" cols="4" v-for="user in users"
          v-bind:key="'user' + user._id" @click="$emit('userId', user._id)">

          <AvatarCircle class="avatar-circle" :isSelected="playerSelected(user._id)" :id="user._id"
            :isReserved="playerReserved(user._id)" :username="user.username" :realname="user.realname" :size="158"
            :sizeInner="120" :selectable="true"></AvatarCircle>

        </b-col>
      </b-row>

      <div class="continue-error" v-html="continueError"></div>

      <div class="shared-back-button" v-html="T('button_back')" @click="$emit('back')">
      </div>

      <b-button class="shared-back-button btn-next" v-if="isHost" :disabled="canContinue === false"
        @click="$emit('next-clicked')" v-html="T('button_continue')">
      </b-button>

    </div>
  </div>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';
import Game, { NoPlayer, getUnassignedPlayers, getUserId } from '../../../shared_fca/game';
import { T } from '@/App.vue';
import { users } from '../../../shared_fca/room_user';
import AvatarCircle from "../components/AvatarCircle.vue";

export default Vue.extend({
  name: 'PlayerSelect',
  props: {
    game: Object as PropType<Game>,
    isHost: Boolean,
    offline: Boolean,
    myUUID: String,
    playGame: Boolean,
  },
  components: {
    AvatarCircle,
  },
  computed: {

    canContinue: {
      cache: false,
      get(): boolean {

        if (getUserId(this.game, this.myUUID) === NoPlayer) {
          return false;
        }

        if (getUnassignedPlayers(this.game) > 0) {
          return false;
        }

        if (this.totalPlayers < 2 && this.offline == false) {
          return false;
        }

        if (this.isHost == false) {
          return false;
        }

        return true;
      }
    },

    totalPlayers: {
      cache: false,
      get(): number {
        return Object.keys(this.game.networkPlayers).length;
      }
    },

    continueError: {
      cache: false,
      get(): string {

        //No error messages for single player
        if (this.offline) {
          return "";
        }

        //Do we need to choose?
        if (getUserId(this.game, this.myUUID) === NoPlayer) {
          return T("player_select_need_to_select");
        }

        const unassignedPlayers = getUnassignedPlayers(this.game);
        if (unassignedPlayers > 0) {
          return T("player_select_" + unassignedPlayers + "playerleft");
        }


        if (this.isHost === false) {
          return T("player_select_waiting_for_host");
        }

        return T("player_select_host_" + this.totalPlayers + "totalplayers");

      }
    }
  },
  data() {
    return {
      users,
    };
  },
  methods: {

    playerSelected(userId: string): boolean {
      return getUserId(this.game, this.myUUID) == userId;
    },

    playerReserved(userId: string): boolean {

      return this.game.idToPlayerUUID[userId] != NoPlayer
        && this.game.idToPlayerUUID[userId] != this.myUUID;
    },

    T(key: string): string {
      return T(key);
    }

  },
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.player-select-header {
  width: 100%;
  margin-top: 108px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: Rubik;
  font-size: 60px;
  font-weight: 700;
  line-height: 71.1px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  color: white;
}

.btnUser p {
  margin-top: 20px;
  margin-bottom: 51px;
}

.player-selection-box {
  width: 724px;
  margin-top: 14px;
  margin-left: auto;
  margin-right: auto;
}


.btn-next {
  background-color: #B2CD30;
  left: unset;
  right: 77px;
}

.btn-select-container {
  top: 725px;
  position: absolute;
  display: flex;
  width: 100%;
  justify-content: center;
}

.avatar-circle {
  margin-bottom: 100px;
}

.continue-error {
  height: 29px;
  width: 100%;
  color: #FFFFFF;
  font-family: Rubik;
  font-size: 24px;
  letter-spacing: 0.02px;
  line-height: 28px;
  text-align: center;
  position: absolute;
  bottom: 120px;
  pointer-events: none;
}
</style>
